import { ChangeDetectionStrategy, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { distinctUntilChanged, fromEvent, map, merge, Subject, takeUntil } from 'rxjs';
import { ToolbarSearchService } from './toolbar-search.service';

@Component({
  selector: 'ss-toolbar-search',
  templateUrl: './toolbar-search.component.html',
  styleUrls: ['./toolbar-search.component.css'],
  host: {
    class: 'border-radius-small'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarSearchComponent {

  readonly #destroy = new Subject<void>()



  @ViewChild(MatInput, { read: ElementRef<HTMLInputElement> })
  private _input: ElementRef<HTMLInputElement>


  readonly searchSubject = this._toolbarSearchService.searchSubject;

  constructor(
    private readonly _toolbarSearchService: ToolbarSearchService
  ) {

  }


  ngAfterViewInit() {


    merge(
      fromEvent(this._input.nativeElement, 'change'),
      fromEvent(this._input.nativeElement, 'keyup')
    )
      .pipe(
        takeUntil(this.#destroy),
        map(() => this._input.nativeElement.value),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.searchSubject.next(value)
      })
  }




  @HostListener('click')
  focusInput() {

    this._input.nativeElement.focus();
    this._input.nativeElement.select();
  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
